import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { message, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import cs from './index.module.scss';
import { useStore } from '@/models';
import { useSettingList, usePartnerList } from '@/hooks/footer';
import CloseFilledIcon from '@/components/icons/CloseFilledIcon';
import { LANG_LIST } from '@/config/const';

import logo from '@/assets/logo/logo@2x.png';
import qrLogo from '@/assets/logo/zimulogo.png';
import QRCode, { QRCodeSVG } from 'qrcode.react';
import homeDownLoad1 from '@/assets/img/pcHome/homeDownLoad1.png';
import homeDownLoad2 from '@/assets/img/pcHome/homeDownLoad2.png';
import homeDownLoad3 from '@/assets/img/pcHome/homeDownLoad3.png';
import { openMediaUrl } from '@/utils/telegram';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { account, home } = useStore();
  const { lang } = account;
  const settingList = useSettingList();
  const communityList = usePartnerList();
  const { androidUrl, iosAppstoreUrl, googleUrl, confList } = home;
  const { larding_page_url } = confList;
  const [visible, setVisible] = useState(false);
  const currentLang = useMemo(() => {
    const temp = LANG_LIST.find((item: any) => lang === item.value);
    if (temp) {
      return temp.label;
    }
  }, [lang]);
  const handleCancel = () => {
    setVisible(false);
  };
  const toAnd = () => {
    message.success(t('home.jqqd'));
  };
  const openDownloadUrl = (url: string) => {
    if (url) {
      window.open(url);
      return;
    }
    toAnd();
  };
  const { push } = useHistory();
  const { origin } = window.location;
  return (
    <div className={cs.container}>
      <div className={cs.content}>
        <div className={cs.top}>
          <section className={cx(cs.section, cs.xtDesc)}>
            <img src={logo} className={cs.logo} />

            {/* <h3 className={cs.company}>{t('footer.socialExchange')}</h3> */}
            {/* <p className={cs.copyright}>© 2022 - 2023 dsailufuae.wesdfi,wejfos.com</p> */}
          </section>
          <section className={cs.lanSection}>
            <div>{t('footer.joinLvbitCommunity')}</div>
            <div className={cs.community}>
              {communityList?.map(({ mediaType, Logo }, index) => (
                <a
                  key={index}
                  href="#"
                  onClick={(event) => {
                    event.preventDefault();
                    openMediaUrl(mediaType || '', lang);
                  }}
                >
                  {Logo && typeof Logo === 'function' ? <Logo /> : Logo}
                </a>
              ))}
            </div>
            {/* <Popover placement="bottom-end" content={<DropDownSettingMenu />} width={150}>
              <a>
                <GlobalIconWhite />
                <span className={cx(cs.title)}>
                  {currentLang}
                  <i className={cx('iconfont icon-select_drop', cs.dropDown)} />
                </span>
              </a>
            </Popover> */}
          </section>
        </div>
        <div className={cs.settingBox}>
          <div className={cs.settingBoxLeft}>
            {settingList?.map(({ title, children }, index) => (
              <section className={cx(cs.section)} key={index}>
                <h2>{title}</h2>
                <div>
                  {children?.map(({ title: subTitle, url }, i) => (
                    <a href={url || '#'} target="_blank" rel="noopener noreferrer" key={i}>
                      {subTitle}
                    </a>
                  ))}
                </div>
              </section>
            ))}
          </div>
          <div className={cs.settingBoxRight}>
            <div className={cs.downloadArea}>

              <div className={cs.downloadInfo}>
                <p className={cs.subText}>{t('home.app.footer.download')}</p>
                <p className={cs.platform}>IOS & Android</p>

                <div className={cs.storeButtons}>
                  <div className={cs.storeBtn} onClick={() => openDownloadUrl(iosAppstoreUrl)}>
                    <img className={cs.storeBtnImg} src={homeDownLoad2} alt="" />
                    <div>IOS</div>
                  </div>
                  <div className={cs.storeBtn} onClick={() => openDownloadUrl(androidUrl)}>
                    <img className={cs.storeBtnImg} src={homeDownLoad1} alt="" />
                    <div>Android</div>
                  </div>
                  <div className={cs.storeBtn} onClick={() => openDownloadUrl(googleUrl)}>
                    <img className={cs.storeBtnImg} src={homeDownLoad3} alt="" />
                    <div>Google Play</div>
                  </div>
                </div>
              </div>

              <div className={cs.qr} >
                <QRCodeSVG
                  className="QRCode-qrCode"
                  value={larding_page_url}
                  imageSettings={{
                    src: qrLogo,
                    height: 24,
                    width: 24,
                    excavate: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={cs.line} />
      <div className={cs.rights}>Lvbit ©2024 &nbsp;&nbsp; {origin}</div> */}
    </div>
  );
};

export default observer(Footer);
